import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetCampoAdicionalResponse } from '@shared/services/responses/servico/get-campo-adicional.response';
import { CreateCampoAdicionalResponse } from '@shared/services/responses/servico/create-campo-adicional.response';
import { CampoAdicionalLookupsResponse } from '@shared/services/responses/servico/campo-adicional-lookups.response';
import { CampoAdicionalRequest } from '@shared/services/requests/servico/campo-adicional.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class CampoAdicionalService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'CampoAdicional';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(
    nome: string = '',
    pagina: number = 0,
    tamanhoPagina: number = 20
  ): Observable<GetCampoAdicionalResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (nome) {
      params = params.set('nome', nome);
    }

    return this.httpClient
      .get<GetCampoAdicionalResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getLookups(): Observable<CampoAdicionalLookupsResponse> {
    return this.httpClient
      .get<CampoAdicionalLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateCampoAdicionalResponse> {
    const url = `${this.apiUrl}/idCampoAdicional/${id}`;
    return this.httpClient
      .get<CreateCampoAdicionalResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: CampoAdicionalRequest): Observable<CreateCampoAdicionalResponse> {
    return this.httpClient
      .post<CreateCampoAdicionalResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: CampoAdicionalRequest): Observable<CreateCampoAdicionalResponse> {
    const url = `${this.apiUrl}/idCampoAdicional/${id}`;
    return this.httpClient
      .put<CreateCampoAdicionalResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteBulk(ids: number[]): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/bulk-delete`;
    return this.httpClient
      .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
